var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.2001 16.925H17.8251L14.2001 12.1L11.2501 16.025L9.0501 13.125L6.2001 16.925ZM3.2251 20.775V3.22501H20.7751V20.775H3.2251ZM5.1001 18.9H18.9001V5.10001H5.1001V18.9ZM8.50082 9.93751C8.90034 9.93751 9.23968 9.79768 9.51885 9.51803C9.79802 9.23837 9.9376 8.89878 9.9376 8.49928C9.9376 8.09977 9.79777 7.76042 9.51812 7.48126C9.23846 7.20209 8.89887 7.06251 8.49937 7.06251C8.09986 7.06251 7.76051 7.20233 7.48135 7.48198C7.20218 7.76165 7.0626 8.10123 7.0626 8.50073C7.0626 8.90025 7.20242 9.23959 7.48207 9.51876C7.76174 9.79792 8.10132 9.93751 8.50082 9.93751Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.28749f43a5a6e274d998346dc4c14309.svg";
export { ForwardRef as ReactComponent };